export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-orange-600 to-orange-700 text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/8f0e4cfc-35a0-4a7c-aefb-ee9f6194a911.png"
              alt="Trio HVACR Services"
              className="h-12 w-auto mb-6 brightness-0 invert"
            />
            <p className="text-sm text-white/90 leading-relaxed mb-6">
              Your trusted HVAC expert in Baltimore, MD. Professional heating and cooling solutions for residential and commercial properties.
            </p>
            <div className="flex items-center space-x-4">
              <a href="#" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-instagram-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wide mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('home')}
                  className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer"
                >
                  About Us
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer"
                >
                  Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('reviews')}
                  className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer"
                >
                  Reviews
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wide mb-6">Contact Info</h4>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <i className="ri-phone-fill text-lg mt-0.5"></i>
                <div>
                  <p className="text-sm font-medium">Phone</p>
                  <a href="tel:4433248816" className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                    (443) 324-8816
                  </a>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-map-pin-fill text-lg mt-0.5"></i>
                <div>
                  <p className="text-sm font-medium">Service Area</p>
                  <p className="text-sm text-white/80">Baltimore, MD</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-time-fill text-lg mt-0.5"></i>
                <div>
                  <p className="text-sm font-medium">Hours</p>
                  <p className="text-sm text-white/80">Mon-Sat: 8AM-6PM</p>
                  <p className="text-sm text-white/80">Sunday: Closed</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
            <p className="text-sm text-white/80">
              © 2025 Trio HVACR Services. All rights reserved.
            </p>
            <div className="flex items-center space-x-6">
              <a href="#" className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                Privacy Policy
              </a>
              <a href="#" className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                Terms of Service
              </a>
              <a 
                href="https://readdy.ai/?ref=logo" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
